import * as Yup from 'yup';
import { FormRegExp } from '../../constants/FormRegExp';

export default () =>
  Yup.object().shape({
    feeInPence: Yup.string().matches(FormRegExp.INTEGER, 'Type correct characters'),
    search: Yup.string(),
  });
